import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Reset"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.5 6.72055V3.1573L13.3898 4.20125C12.1983 2.5651 10.2568 1.5 8.06416 1.5C4.43867 1.5 1.5 4.41004 1.5 7.99986C1.5 11.59 4.43867 14.5 8.06416 14.5C11.2337 14.5 13.8787 12.2752 14.4931 9.31659H12.4645C11.8942 11.1889 10.1405 12.5531 8.06416 12.5531C5.52497 12.5531 3.46615 10.5146 3.46615 7.99986C3.46615 5.48544 5.5247 3.4469 8.06416 3.4469C9.69718 3.4469 11.1262 4.2929 11.9413 5.56353L10.7114 6.72028H12.4744L14.5 6.72055Z"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var reset = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { reset as default };
